import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { Container, MaskText, Reveal, Overline, LimeButton, ArrowDot } from "./primitives";

const API = process.env.REACT_APP_BACKEND_URL;
const POINTS = ["Diagnóstico preciso e personalizado", "Estratégia de marketing e vendas alinhada", "Execução prática e focada em resultados"];
const EMPTY = { name: "", email: "", company: "", phone: "", message: "" };

const Field = ({ label, id, textarea, ...rest }) => (
  <label className="block">
    <span className="font-mono-x text-[11px] uppercase tracking-[0.18em] text-slate-600">{label}</span>
    {textarea
      ? <textarea id={id} rows={4} className="mt-2 w-full resize-none border-b-2 border-slate-200 bg-transparent py-2 text-base text-[#0F172A] outline-none transition-colors placeholder:text-slate-400 focus:border-[#1238CE]" {...rest} />
      : <input id={id} className="mt-2 w-full border-b-2 border-slate-200 bg-transparent py-2 text-base text-[#0F172A] outline-none transition-colors placeholder:text-slate-400 focus:border-[#1238CE]" {...rest} />}
  </label>
);

export const Contact = () => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!API) { toast.error("Formulário indisponível no momento."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/contact`, form);
      toast.success("Recebemos sua mensagem! Retornaremos em breve.");
      setForm(EMPTY);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Verifique os campos e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contato" className="grain relative overflow-hidden bg-[#060B19] py-20 text-white lg:py-32" data-testid="contact-section">
      <div className="pointer-events-none absolute -left-40 bottom-0 h-[500px] w-[500px] rounded-full bg-[#1238CE]/30 blur-[120px]" />
      <Container className="relative grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Overline dark>Contato</Overline>
          <MaskText className="font-display mt-6 text-4xl font-bold leading-[1] tracking-[-0.035em] sm:text-6xl"
            lines={["Vamos transformar", "objetivos em", <span className="text-[#CCFF00]">ação.</span>]} />
          <Reveal><p className="mt-6 max-w-sm text-base leading-relaxed text-slate-300">Conte o principal desafio da sua empresa. Eu retorno com os próximos passos para traçarmos o caminho juntos.</p></Reveal>
          <ul className="mt-10 space-y-4">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={i * 0.08}>
                <li className="flex items-center gap-4 text-sm font-medium text-white">
                  <span className="grid h-7 w-7 place-items-center rounded-full border border-[#CCFF00] text-[#CCFF00]"><Check size={14} strokeWidth={3} /></span>{p}
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
        <Reveal className="lg:col-span-6 lg:col-start-7" y={50}>
          <form onSubmit={submit} className="space-y-7 rounded-[28px] bg-white p-7 sm:p-10" data-testid="contact-form">
            <div className="grid gap-7 sm:grid-cols-2">
              <Field label="Nome *" id="c-name" required minLength={2} value={form.name} onChange={set("name")} placeholder="Seu nome" data-testid="contact-form-name-input" />
              <Field label="E-mail *" id="c-email" type="email" required value={form.email} onChange={set("email")} placeholder="voce@empresa.com" data-testid="contact-form-email-input" />
              <Field label="Empresa" id="c-company" value={form.company} onChange={set("company")} placeholder="Nome da empresa" data-testid="contact-form-company-input" />
              <Field label="WhatsApp" id="c-phone" value={form.phone} onChange={set("phone")} placeholder="(00) 00000-0000" data-testid="contact-form-phone-input" />
            </div>
            <Field label="Qual seu principal desafio? *" id="c-msg" textarea required minLength={5} value={form.message} onChange={set("message")} placeholder="Ex.: gerar mais oportunidades qualificadas" data-testid="contact-form-message-input" />
            <LimeButton type="submit" disabled={loading} className="w-full justify-between disabled:opacity-70" data-testid="contact-form-submit-button">
              {loading ? "Enviando..." : "Quero transformar objetivos em ação"}
              {loading ? <span className="grid h-8 w-8 place-items-center"><Loader2 className="h-4 w-4 animate-spin" /></span> : <ArrowDot />}
            </LimeButton>
          </form>
        </Reveal>
      </Container>
    </section>
  );
};
